import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { PanelRight } from 'lucide-react';

export interface PreviewPanelToggleProps {
  open: boolean;
  onToggle: () => void;
  testId?: string;
  /** Set when the frame cannot spare the preview floor. The pin stays, and explains why it will not open. */
  disabledReason?: string;
  /** What the right pane is on this surface: "preview panel" on an index, "details" on a document. */
  paneLabel?: string;
}

export function PreviewPanelToggle({
  open,
  onToggle,
  testId,
  disabledReason,
  paneLabel = 'preview panel',
}: PreviewPanelToggleProps) {
  const blocked = Boolean(disabledReason) && !open;
  const label = open ? `Hide ${paneLabel}` : `Show ${paneLabel}`;
  return (
    <Button
      variant={open ? 'secondary' : 'ghost'}
      size="sm"
      className={cn('h-8 w-8 shrink-0 p-0', blocked && 'cursor-not-allowed opacity-40')}
      title={blocked ? disabledReason : label}
      aria-label={label}
      aria-pressed={open}
      aria-disabled={blocked || undefined}
      data-testid={testId}
      onClick={() => {
        if (blocked) return;
        onToggle();
      }}
    >
      <PanelRight className="h-4 w-4" />
    </Button>
  );
}
